import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AlertController, IonicModule, ModalController, NavParams } from '@ionic/angular';

import { CONVERSATION_STATUS } from 'src/app/constants';
import { AuthService } from 'src/services/auth.service';
import { MessageService } from 'src/services/message.service';
import { SubStatusesService } from 'src/services/sub-statuses.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule],
  selector: 'app-edit-sub-status',
  templateUrl: './edit-sub-status.component.html',
  styleUrls: ['./edit-sub-status.component.scss'],
})
export class EditSubStatusComponent implements OnInit {
  @ViewChild('nameInput', { static: false }) nameInput;

  isLoading = false;
  name: string;
  description: string;
  type: string;
  id?: string;
  projectId: string;
  statusTypes = Object.values(CONVERSATION_STATUS);
  typeLabels = Object.keys(CONVERSATION_STATUS).reduce((acc, key) => {
    acc[CONVERSATION_STATUS[key]] = key.replace(/_/g, ' ').toLowerCase();
    return acc;
  }, {});
  CONVERSATION_STATUS = CONVERSATION_STATUS;

  constructor(
    navParams: NavParams,
    public authService: AuthService,
    private modalCtrl: ModalController,
    private msgSrvc: MessageService,
    private alertCtrl: AlertController,
    private subStatusesService: SubStatusesService,
  ) {
    this.id = navParams.get('id');
    this.projectId = navParams.get('projectId');
    this.type = navParams.get('type');
  }

  ngOnInit(): void {
    if (this.id) {
      this.loadSubStatus();
    } else {
      setTimeout(() => this.nameInput.setFocus(), 500);
    }
  }

  async loadSubStatus() {
    try {
      const subStatus = await this.subStatusesService.getById(this.id);

      this.name = subStatus.name;
      this.description = subStatus['description'] || '';
      this.type = subStatus.type;
      this.projectId = subStatus.projectId;
    } catch (error) {
      await this.msgSrvc.showError(error);
    }
  }

  async submit() {
    if (!this.name) {
      await this.msgSrvc.show('Please enter a name.');
      return;
    }

    if (!this.type) {
      await this.msgSrvc.show('Please select a status type.');
      return;
    }

    this.isLoading = true;

    try {
      const payload: any = {
        name: this.name,
      };

      if (this.description) {
        payload.description = this.description;
      }

      if (this.id) {
        await this.subStatusesService.updatePartial(this.id, payload);
      } else {
        await this.subStatusesService.create({
          ...payload,
          type: this.type,
          projectId: this.projectId,
        });
      }

      this.modalCtrl.dismiss();
    } catch (error) {
      await this.msgSrvc.showError(error);
    } finally {
      this.isLoading = false;
    }
  }

  async delete() {
    try {
      const alert = await this.alertCtrl.create({
        header: 'Delete Status',
        message: 'Are you sure you want to delete this status? This action cannot be undone.',
        buttons: [
          {
            text: 'Cancel',
            role: 'cancel',
          },
          {
            text: 'Delete',
            role: 'destructive',
            handler: async () => {
              this.isLoading = true;
              await this.subStatusesService.delete(this.id);
              this.modalCtrl.dismiss();

              this.isLoading = false;
            },
          },
        ],
      });

      await alert.present();
    } catch (error) {
      await this.msgSrvc.showError(error);
    } finally {
      this.isLoading = false;
    }
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }
}
